import Base from './base'
import Vue from 'vue'
import comm from '../assets/lib/comm'

class Scene extends Base {
  constructor () {
    super('Scene')
    this.source = 1
  }

  async load (zoneId) {
    let scenes = await this.get(zoneId)
    Vue._logger.debugger(scenes)
    window.vm.$store.commit('SET_SCENE', scenes.data.map(d => {
      return {
        id: d.id,
        name: d.name,
        alias: d.alias,
        cmd: d.cmd,
        code: d.code,
        icon: d.icon,
        remark: d.remark,
        type: d.type,
        zoneId: d.zoneId
      }
    }))
  }

  async setVisible (zoneId, sceneId, visible) {
    const loading = comm.showLoading()
    try {
      Vue._logger.debugger(Vue._config.api.sceneVisible)
      const result = await Vue.axios.put(Vue._config.api.sceneVisible.replace(':zoneId', zoneId), {
        sceneId: sceneId,
        visible: visible
      })
      if (result.data.code === 1) {
        return true
      } else {
        throw new Error(`${visible ? '显示' : '隐藏'}场景失败`)
      }
    } catch (e) {
      throw e
    } finally {
      comm.closeLoading(loading)
    }
  }

  async getSystemScene (zoneId) {
    try {
      Vue._logger.debugger(Vue._config.api.scene)
      const result = await Vue.axios.get(Vue._config.api.scene.replace(':zoneId', zoneId), {
        params: {
          visible: 2,
          isSimple: 1,
          type: 1
        }
      })
      if (result.data.code === 1) {
        return result.data
      } else {
        throw new Error('获取场景信息失败')
      }
    } catch (e) {
      throw e
    }
  }

  async get (zoneId) {
    try {
      Vue._logger.debugger(Vue._config.api.scene)
      const result = await Vue.axios.get(Vue._config.api.scene.replace(':zoneId', zoneId))
      if (result.data.code === 1) {
        return result.data
      } else {
        throw new Error('获取场景信息失败')
      }
    } catch (e) {
      throw e
    }
  }

  async active (sceneId) {
    const loading = comm.showLoading('#app', '正在切换场景，请稍后...')
    try {
      Vue._logger.debugger(Vue._config.api.activeScene)
      const result = await Vue.axios.put(Vue._config.api.activeScene.replace(':sceneId', sceneId), {
        zoneId: window.vm.$store.state.zone.id,
        logFrom: this.source
      })
      if (result.data.code === 1) {
        return true
      } else {
        throw new Error('激活场景失败')
      }
    } catch (e) {
      throw e
    } finally {
      comm.closeLoading(loading)
    }
  }

  async add (zoneId, scene) {
    try {
      Vue._logger.debugger(Vue._config.api.scenes)
      const result = await Vue.axios.post(Vue._config.api.scenes, {
        ...scene,
        cmd: JSON.stringify(scene.cmd),
        zoneId: zoneId
      }, { params: { isZone: true } })
      if (result.data.code === 1) {
        return result.data
      } else {
        throw new Error('添加场景信息失败')
      }
    } catch (e) {
      throw e
    }
  }

  async edit (zoneId, scene) {
    try {
      Vue._logger.debugger(Vue._config.api.scenes)
      const result = await Vue.axios.put(`${Vue._config.api.scenes}/${scene.id}`, {
        ...scene,
        cmd: JSON.stringify(scene.cmd),
        zoneId: zoneId
      })
      if (result.data.code === 1) {
        return result.data
      } else {
        throw new Error('编辑场景信息失败')
      }
    } catch (e) {
      throw e
    }
  }

  async delete (sceneId) {
    try {
      Vue._logger.debugger(Vue._config.api.scenes)
      const result = await Vue.axios.delete(`${Vue._config.api.scenes}/${sceneId}`)
      if (result.data.code === 1) {
        return result.data
      } else {
        throw new Error('删除场景信息失败')
      }
    } catch (e) {
      throw e
    }
  }
}

export default new Scene()
